module.exports = __webpack_public_path__ + "media/images/covid/banner/art_bot/vi-2a369c66726a882117d61e4f0e4d3321.jpg";